export type RolesAndPermissions = {
  group: string;
  actions: {
    action: string;
    permissions: {
      admin: boolean | string;
      instructor: boolean | string;
      ta: boolean | string;
    };
  }[];
}[];

const rolesAndPermissions: RolesAndPermissions = [
  {
    group: 'Course Management',
    actions: [
      {
        action: 'Extend course end date',
        permissions: {
          admin: true,
          instructor: false,
          ta: false,
        },
      },
      {
        action: 'Archive a completed course',
        permissions: {
          admin: true,
          instructor: false,
          ta: false,
        },
      },
      {
        action: 'Delete a course',
        permissions: {
          admin: true,
          instructor: false,
          ta: false,
        },
      },
    ],
  },
  {
    group: 'Enrollments',
    actions: [
      {
        action: 'Add new students',
        permissions: {
          admin: true,
          instructor: false,
          ta: false,
        },
      },
      {
        action: 'Add new instructors',
        permissions: {
          admin: true,
          instructor: false,
          ta: false,
        },
      },
      {
        action: 'Add new TAs',
        permissions: {
          admin: true,
          instructor: false,
          ta: false,
        },
      },
      {
        action: "Edit course team members' roles",
        permissions: {
          admin: true,
          instructor: false,
          ta: false,
        },
      },
      {
        action: 'Remove students',
        permissions: {
          admin: true,
          instructor: false,
          ta: false,
        },
      },
      {
        action: 'Remove instructors',
        permissions: {
          admin: true,
          instructor: false,
          ta: false,
        },
      },
      {
        action: 'Remove TAs',
        permissions: {
          admin: true,
          instructor: false,
          ta: false,
        },
      },
    ],
  },
  {
    group: 'Class Management',
    actions: [
      {
        action: 'Assign class in-charge',
        permissions: {
          admin: true,
          instructor: 'As Class In-charge',
          ta: false,
        },
      },
      {
        action: 'Edit class team',
        permissions: {
          admin: true,
          instructor: 'As Class In-charge',
          ta: false,
        },
      },
      {
        action: 'Be a class in-charge',
        permissions: {
          admin: true,
          instructor: true,
          ta: false,
        },
      },
      {
        action: 'Be a class assistant',
        permissions: {
          admin: true,
          instructor: true,
          ta: false,
        },
      },
      {
        action: 'Add a new class',
        permissions: {
          admin: true,
          instructor: true,
          ta: false,
        },
      },
      {
        action: 'Edit class schedule and venue',
        permissions: {
          admin: 'As Class In-charge',
          instructor: 'As Class In-charge',
          ta: false,
        },
      },
      {
        action: 'Cancel Class',
        permissions: {
          admin: 'As Class In-charge',
          instructor: 'As Class In-charge',
          ta: false,
        },
      },
      {
        action: 'Remove classes with no-record',
        permissions: {
          admin: 'As Class In-charge',
          instructor: 'As Class In-charge',
          ta: false,
        },
      },
    ],
  },
  {
    group: 'Activities',
    actions: [
      {
        action: 'Post announcements',
        permissions: {
          admin: true,
          instructor: true,
          ta: false,
        },
      },
      {
        action: 'Create and publish assignments',
        permissions: {
          admin: true,
          instructor: true,
          ta: false,
        },
      },
      {
        action: 'Grade assignments',
        permissions: {
          admin: true,
          instructor: true,
          ta: false,
        },
      },
      {
        action: 'Create and publish polls',
        permissions: {
          admin: 'As Class In-charge',
          instructor: 'As Class In-charge',
          ta: false,
        },
      },
      {
        action: 'Create and publish quizzes',
        permissions: {
          admin: 'As Class In-charge',
          instructor: 'As Class In-charge',
          ta: false,
        },
      },
      {
        action: 'Create and publish resources',
        permissions: {
          admin: 'As Class In-charge',
          instructor: 'As Class In-charge',
          ta: false,
        },
      },
      {
        action: 'Create and publish discussions',
        permissions: {
          admin: 'As Class In-charge',
          instructor: 'As Class In-charge',
          ta: false,
        },
      },
      {
        action: 'Create and publish class summary',
        permissions: {
          admin: 'As Class In-charge',
          instructor: 'As Class In-charge',
          ta: false,
        },
      },
    ],
  },
  {
    group: 'Attendance',
    actions: [
      {
        action: 'Record automatic attendance',
        permissions: {
          admin: 'As Class In-charge',
          instructor: 'As Class In-charge',
          ta: 'As Class Assistant',
        },
      },
      {
        action: 'Manually edit attendance',
        permissions: {
          admin: 'As Class In-charge',
          instructor: 'As Class In-charge',
          ta: 'As Class Assistant',
        },
      },
    ],
  },
  {
    group: 'Online Lectures',
    actions: [
      {
        action: 'Create and Broadcast Zoom meetings',
        permissions: {
          admin: 'As Class In-charge',
          instructor: 'As Class In-charge',
          ta: false,
        },
      },
      {
        action: 'Publish Zoom meeting recordings',
        permissions: {
          admin: 'As Class In-charge',
          instructor: 'As Class In-charge',
          ta: false,
        },
      },
    ],
  },
];

export default rolesAndPermissions;
